/* Gioco "Spegni i pensieri di Carol" (sections/gioco-carol.liquid). Niente librerie.
   - stati sul contenitore (data-stato): pronto, gioco, pausa, respiro, fine; il CSS
     mostra veli e comandi giusti per ogni stato
   - un solo requestAnimationFrame: orologio della partita, salita dei pensieri
     (solo transform e opacity), respiro di Carol; si ferma in pausa, a scheda
     nascosta (visibilitychange), a scena fuori schermo e quando la partita finisce
   - i pensieri sono <button> veri; con la tastiera il pensiero che ha il focus si
     ferma ad aspettare; spento uno, il focus passa al pensiero dopo
   - movimento ridotto: i pensieri compaiono in posti fissi e svaniscono in
     dissolvenza, stessa partita
   - pensieri del giorno e "pensiero del giorno" scelti con un seme = data;
     tempo migliore in localStorage (try/catch)
   - eventi Shopify.analytics.publish: profumidicasa:gioco_inizio, gioco_fine,
     gioco_candela_click (try/catch) */
(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';
  var CHIAVE = 'pdc_gioco_carol';
  var INTERVALLO = 2300;
  var VITA_FERMA = 9000;
  var EASE = 'cubic-bezier(0.23, 1, 0.32, 1)';
  var tastiera = false;

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ') tastiera = true;
  }, true);
  document.addEventListener('pointerdown', function () {
    tastiera = false;
  }, true);

  function pubblica(nome, dati) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('profumidicasa:' + nome, dati);
      }
    } catch (e) {}
  }

  function giorno() {
    var d = new Date();
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }

  function hash(s) {
    var h = 2166136261;
    for (var i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function caso(seme) {
    return function () {
      seme = (seme + 0x6d2b79f5) | 0;
      var t = Math.imul(seme ^ (seme >>> 15), 1 | seme);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function mescola(a, r) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(r() * (i + 1));
      var x = a[i];
      a[i] = a[j];
      a[j] = x;
    }
    return a;
  }

  function limita(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  function Gioco(root) {
    var q = function (s) {
      return root.querySelector(s);
    };
    var ds = root.dataset;
    var scena = q('[data-scena]');
    var cielo = q('[data-cielo]');
    var fumi = q('[data-fumi]');
    var carol = q('[data-carol]');
    var fiamma = q('[data-fiamma]');
    var alone = q('[data-alone]');
    var conta = q('[data-conta]');
    var voce = q('[data-annuncio]');
    var parola = q('[data-respiro-parola]');
    var titoloEsito = q('[data-esito-titolo]');
    var recordEsito = q('[data-esito-record]');
    var whatsapp = q('[data-whatsapp]');
    var copiaTesto = q('[data-copia-testo]');
    var copiaOrig = copiaTesto ? copiaTesto.textContent : '';
    var btn = {};
    root.querySelectorAll('[data-azione]').forEach(function (b) {
      btn[b.getAttribute('data-azione')] = b;
    });

    var SOGLIA = parseInt(ds.soglia, 10) || 12;
    var DURATA = (parseInt(ds.durata, 10) || 60) * 1000;
    var URL_PAGINA = ds.url || location.href.split('#')[0];
    var T = {
      spegni: ds.tSpegni || '',
      conta: ds.tConta || '[n]',
      annuncio: ds.tAnnuncio || '[n]',
      inizio: ds.tInizio || '',
      pausa: ds.tPausa || '',
      quieta: ds.tQuieta || '',
      tempoScaduto: ds.tTempoScaduto || '',
      inspira: ds.tInspira || '',
      espira: ds.tEspira || '',
      finale: ds.tFinale || '[s]',
      finaleTempo: ds.tFinaleTempo || '[n]',
      record: ds.tRecord || '[s]',
      nuovoRecord: ds.tNuovoRecord || '',
      condividi: ds.tCondividi || '',
      condividiTempo: ds.tCondividiTempo || '',
      copiato: ds.tCopiato || '',
      copiaErrore: ds.tCopiaErrore || ''
    };

    var famiglie = [];
    try {
      famiglie = (JSON.parse(q('[data-pensieri]').textContent).famiglie || [])
        .map(function (f) {
          return {
            id: f.id,
            pensieri: String(f.pensieri || '')
              .split(/\r?\n/)
              .map(function (s) {
                return s.trim();
              })
              .filter(Boolean)
          };
        })
        .filter(function (f) {
          return f.pensieri.length;
        });
    } catch (e) {}
    if (!famiglie.length || !scena || !cielo) return;

    // Pensieri di oggi: da ogni famiglia fino a 4, alternati; il primo e' il pensiero del giorno
    var data = giorno();
    var r = caso(hash(data));
    var mazzi = mescola(famiglie.slice(), r).map(function (f) {
      return mescola(f.pensieri.slice(), r)
        .slice(0, 4)
        .map(function (t) {
          return { testo: t, fam: f.id };
        });
    });
    var lista = [];
    for (var giro = 0; giro < 4; giro++) {
      mazzi.forEach(function (m) {
        if (m[giro]) lista.push(m[giro]);
      });
    }
    var oggi = lista[0];

    var ridotto = window.matchMedia('(prefers-reduced-motion: reduce)');
    var stato = 'pronto';
    var bolle = [];
    var raf = 0;
    var ultimo = 0;
    var tempo = 0;
    var prossima = 0;
    var indice = 0;
    var spenti = 0;
    var conti = {};
    var ultimaFam = null;
    var ultimaCorsia = -1;
    var fase = 0;
    var tRespiro = 0;
    var timerRespiro = 0;
    var timerParola = 0;
    var quieta = false;
    var secondi = 0;
    var scelta = null;
    var testoCondividi = '';
    var W = 0;
    var H = 0;
    var testaX = 0;
    var testaY = 0;
    var corsie = [];
    var posti = [];
    var maxBolle = 4;

    function misura() {
      W = scena.clientWidth;
      H = scena.clientHeight;
      var rs = scena.getBoundingClientRect();
      var rc = carol.getBoundingClientRect();
      testaX = rc.left - rs.left + rc.width * 0.52;
      testaY = rc.top - rs.top + rc.height * 0.3;
      var stretta = W < 560;
      maxBolle = stretta ? 4 : 5;
      corsie = stretta ? [0.03, 0.51] : [0.04, 0.35, 0.66];
      posti = stretta
        ? [[0.03, 0.05], [0.51, 0.08], [0.03, 0.24], [0.51, 0.27], [0.03, 0.43], [0.51, 0.46]]
        : [[0.04, 0.05], [0.35, 0.08], [0.66, 0.05], [0.04, 0.3], [0.66, 0.3], [0.35, 0.33]];
    }

    function imposta(s) {
      stato = s;
      root.setAttribute('data-stato', s);
    }

    // Il focus su un elemento appena mostrato: se Chrome lo rifiuta perche' l'elemento
    // che lo aveva sta sparendo (display:none), si riprova al fotogramma dopo
    function metti(el) {
      if (!el) return;
      el.focus({ preventScroll: true });
      if (document.activeElement !== el) {
        requestAnimationFrame(function () {
          if (el.isConnected) el.focus({ preventScroll: true });
        });
      }
    }

    function annuncia(testo) {
      if (!voce || !testo) return;
      voce.textContent = '';
      setTimeout(function () {
        voce.textContent = testo;
      }, 60);
    }

    function leggiRecord() {
      try {
        var v = JSON.parse(localStorage.getItem(CHIAVE) || 'null');
        return v && v.migliore > 0 ? v.migliore : 0;
      } catch (e) {
        return 0;
      }
    }

    function salvaRecord(s) {
      try {
        localStorage.setItem(CHIAVE, JSON.stringify({ migliore: s, data: data }));
      } catch (e) {}
    }

    function mostraPronto() {
      var el = q('[data-oggi]');
      var testo = q('[data-oggi-testo]');
      if (el && testo && oggi) {
        testo.textContent = oggi.testo;
        el.hidden = false;
      }
      var rec = q('[data-record]');
      var m = leggiRecord();
      if (rec) {
        rec.hidden = !m;
        if (m) rec.textContent = T.record.replace('[s]', m);
      }
    }

    // ---- Ciclo ----

    function avviaCiclo() {
      if (raf) return;
      ultimo = performance.now();
      raf = requestAnimationFrame(ciclo);
    }

    function fermaCiclo() {
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
    }

    function ciclo(ora) {
      raf = 0;
      var dt = limita(ora - ultimo, 0, 64);
      ultimo = ora;
      if (stato === 'gioco') {
        tempo += dt;
        if (tempo >= prossima) {
          if (bolle.length < maxBolle) {
            nasce();
            prossima = tempo + (indice < 3 ? 1500 : INTERVALLO);
          } else {
            prossima = tempo + 500;
          }
        }
        muovi(dt);
        respira(dt);
        if (tempo >= DURATA) fine(false);
      } else if (stato === 'respiro') {
        tRespiro += dt;
        respira(dt);
      }
      if (stato === 'gioco' || stato === 'respiro') raf = requestAnimationFrame(ciclo);
    }

    // ---- Pensieri ----

    function nasce() {
      var p = lista[indice % lista.length];
      indice++;
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'gc-pensiero';
      var n = document.createElement('span');
      n.className = 'gc-pensiero__nuvola';
      var nascosto = document.createElement('span');
      nascosto.className = 'visually-hidden';
      nascosto.textContent = T.spegni + ' ';
      n.appendChild(nascosto);
      n.appendChild(document.createTextNode(p.testo));
      el.appendChild(n);
      el.style.transform = 'translate3d(-999px,0,0)';
      var b = { el: el, fam: p.fam, eta: 0, fase: Math.random() * 6.283, ferma: false, morto: false, o: 1 };
      cielo.appendChild(el);
      b.w = el.offsetWidth;
      b.h = el.offsetHeight;

      if (ridotto.matches) {
        var liberi = posti.filter(function (_, i) {
          return !bolle.some(function (x) {
            return x.posto === i;
          });
        });
        var scelto = liberi[Math.floor(Math.random() * liberi.length)] || posti[0];
        b.posto = posti.indexOf(scelto);
        b.x = limita(scelto[0] * W, 6, W - b.w - 6);
        b.y = scelto[1] * H;
        el.style.transform = 'translate3d(' + b.x.toFixed(1) + 'px,' + b.y.toFixed(1) + 'px,0)';
      } else {
        ultimaCorsia = (ultimaCorsia + 1 + (corsie.length > 2 && Math.random() < 0.4 ? 1 : 0)) % corsie.length;
        b.corsia = ultimaCorsia;
        b.x0 = testaX - b.w * 0.22;
        b.y0 = testaY - b.h - 8;
        b.y1 = -b.h - 24;
        b.T = ((b.y0 - b.y1) / Math.max(1, H * 0.075)) * 1000;
        muoviUna(b);
      }

      el.addEventListener('click', function () {
        spegni(b);
      });
      el.addEventListener('focus', function () {
        if (tastiera) b.ferma = true;
      });
      el.addEventListener('blur', function () {
        b.ferma = false;
      });
      el.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') b.ferma = true;
      });
      el.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'mouse' && document.activeElement !== el) b.ferma = false;
      });
      bolle.push(b);
      if (tastiera && document.activeElement === cielo) el.focus({ preventScroll: true });
    }

    function muoviUna(b) {
      var p = b.eta / b.T;
      var k = Math.min(1, p / 0.3);
      k = 1 - (1 - k) * (1 - k);
      var xc = corsie[b.corsia] * W;
      var x = b.x0 + (xc - b.x0) * k + Math.sin((b.eta / 2800) * 6.283 + b.fase) * 6 * k;
      b.x = limita(x, 6, W - b.w - 6);
      b.y = b.y0 + (b.y1 - b.y0) * p;
      b.el.style.transform = 'translate3d(' + b.x.toFixed(1) + 'px,' + b.y.toFixed(1) + 'px,0)';
      var o = p > 0.82 ? Math.max(0, (1 - p) / 0.18) : 1;
      if (Math.abs(o - b.o) > 0.01) {
        b.o = o;
        b.el.style.opacity = o.toFixed(2);
      }
      return p;
    }

    function muovi(dt) {
      for (var i = bolle.length - 1; i >= 0; i--) {
        var b = bolle[i];
        if (!b.ferma) b.eta += dt;
        if (ridotto.matches || b.T === undefined) {
          if (b.eta > VITA_FERMA) via(b, true);
        } else if (muoviUna(b) >= 1) {
          via(b, false);
        }
      }
    }

    function togli(b) {
      var i = bolle.indexOf(b);
      if (i > -1) bolle.splice(i, 1);
      b.morto = true;
    }

    function via(b, dissolvi) {
      var aveva = document.activeElement === b.el;
      togli(b);
      if (dissolvi) {
        b.el.tabIndex = -1;
        b.el.classList.add('gc-pensiero--via');
        setTimeout(function () {
          b.el.remove();
        }, 520);
      } else {
        b.el.remove();
      }
      if (aveva) focusDopo();
    }

    function focusDopo() {
      var c = bolle[0];
      (c ? c.el : cielo).focus({ preventScroll: true });
    }

    function spegni(b) {
      if (b.morto || stato !== 'gioco') return;
      var aveva = document.activeElement === b.el;
      togli(b);
      spenti++;
      conti[b.fam] = (conti[b.fam] || 0) + 1;
      ultimaFam = b.fam;
      b.el.tabIndex = -1;
      b.el.setAttribute('aria-hidden', 'true');
      b.el.classList.add('gc-pensiero--spento');
      fumo(b.x + b.w * 0.5, b.y + b.h * 0.45);
      setTimeout(function () {
        b.el.remove();
      }, 480);
      if (aveva) focusDopo();
      aggiornaFiamma();
      aggiornaConta();
      if (spenti >= SOGLIA) {
        fine(true);
      } else if (spenti % 3 === 0) {
        annuncia(T.annuncio.replace('[n]', spenti));
      }
    }

    function fumo(x, y) {
      while (fumi.childElementCount > 5) fumi.firstChild.remove();
      var s = document.createElementNS(NS, 'svg');
      s.setAttribute('class', 'gc-fumo');
      s.setAttribute('viewBox', '0 0 40 90');
      s.setAttribute('focusable', 'false');
      var tratti = ['M20 86C9 72 31 62 20 48S9 24 22 4', 'M24 84C15 72 34 60 25 47S14 26 28 9'].map(function (d) {
        var p = document.createElementNS(NS, 'path');
        p.setAttribute('d', d);
        p.setAttribute('pathLength', '1');
        p.style.strokeDasharray = '1 1';
        p.style.strokeDashoffset = ridotto.matches ? '0' : '1';
        s.appendChild(p);
        return p;
      });
      var t0 = 'translate(' + (x - 25).toFixed(1) + 'px,' + (y - 90).toFixed(1) + 'px)';
      s.style.transform = t0;
      fumi.appendChild(s);
      var togliFumo = function () {
        s.remove();
      };
      if (!s.animate) {
        setTimeout(togliFumo, 900);
        return;
      }
      if (ridotto.matches) {
        s.animate([{ opacity: 0.8 }, { opacity: 0 }], { duration: 900, easing: 'ease', fill: 'forwards' }).onfinish = togliFumo;
        return;
      }
      tratti.forEach(function (p, i) {
        p.animate([{ strokeDashoffset: 1 }, { strokeDashoffset: 0 }], {
          duration: 900 + i * 200,
          delay: i * 90,
          easing: EASE,
          fill: 'forwards'
        });
      });
      s.animate(
        [
          { opacity: 1, transform: t0 },
          { opacity: 1, transform: t0 + ' translateY(-8px)', offset: 0.45 },
          { opacity: 0, transform: t0 + ' translateY(-30px)' }
        ],
        { duration: 1600, easing: EASE, fill: 'forwards' }
      ).onfinish = togliFumo;
    }

    function aggiornaFiamma() {
      var p = Math.min(1, spenti / SOGLIA);
      fiamma.style.transform = 'scale(' + (0.38 + 0.62 * p).toFixed(3) + ')';
      alone.style.opacity = (0.15 + 0.55 * p).toFixed(2);
    }

    function aggiornaConta() {
      if (conta) conta.textContent = T.conta.replace('[n]', spenti);
    }

    // Carol respira: veloce e corto all'inizio, lento quando la mente si calma
    function respira(dt) {
      if (ridotto.matches) return;
      var s;
      if (stato === 'respiro') {
        s = 1 + 0.022 * Math.sin(Math.PI * Math.min(1, tRespiro / 3000));
      } else {
        var p = Math.min(1, spenti / SOGLIA);
        fase += (dt / (1900 + 2700 * p)) * 6.283;
        s = 1 + (0.008 + 0.006 * p) * Math.sin(fase);
      }
      carol.style.transform = 'scale(1,' + s.toFixed(4) + ')';
    }

    function pulisci() {
      bolle = [];
      cielo.textContent = '';
      fumi.textContent = '';
    }

    function riposo() {
      fiamma.style.transform = '';
      alone.style.opacity = '';
      carol.style.transform = '';
    }

    // ---- Stati ----

    function inizia() {
      clearTimeout(timerRespiro);
      clearTimeout(timerParola);
      fermaCiclo();
      misura();
      pulisci();
      spenti = 0;
      conti = {};
      ultimaFam = null;
      ultimaCorsia = -1;
      tempo = 0;
      prossima = 0;
      indice = 0;
      fase = 0;
      root.classList.remove('gc--ripiego');
      imposta('gioco');
      cielo.removeAttribute('inert');
      aggiornaFiamma();
      aggiornaConta();
      var rg = scena.parentNode.getBoundingClientRect();
      if (rg.top < 0 || rg.bottom > window.innerHeight) {
        scena.parentNode.scrollIntoView({ block: 'nearest', behavior: ridotto.matches ? 'auto' : 'smooth' });
      }
      metti(cielo);
      annuncia(T.inizio);
      pubblica('gioco_inizio', { pensiero_del_giorno: oggi.testo, data: data, pagina: location.pathname });
      avviaCiclo();
    }

    function pausa(auto) {
      if (stato !== 'gioco') return;
      var dentro = root.contains(document.activeElement);
      fermaCiclo();
      imposta('pausa');
      cielo.setAttribute('inert', '');
      if (dentro || !auto) metti(btn.riprendi);
      annuncia(T.pausa);
    }

    function riprendi() {
      if (stato !== 'pausa') return;
      imposta('gioco');
      cielo.removeAttribute('inert');
      var c = bolle[0];
      metti(c && tastiera ? c.el : cielo);
      avviaCiclo();
    }

    function esci() {
      clearTimeout(timerRespiro);
      clearTimeout(timerParola);
      fermaCiclo();
      pulisci();
      riposo();
      root.classList.remove('gc--ripiego');
      cielo.removeAttribute('inert');
      imposta('pronto');
      mostraPronto();
      metti(btn.inizia);
    }

    function scegliFamiglia() {
      var max = 0;
      var pari = [];
      famiglie.forEach(function (f) {
        var c = conti[f.id] || 0;
        if (c > max) {
          max = c;
          pari = [f.id];
        } else if (c === max && c > 0) {
          pari.push(f.id);
        }
      });
      if (!max) return oggi.fam;
      if (pari.length === 1) return pari[0];
      if (pari.indexOf(ultimaFam) > -1) return ultimaFam;
      if (pari.indexOf(oggi.fam) > -1) return oggi.fam;
      return pari[0];
    }

    function fine(mente) {
      if (stato !== 'gioco') return;
      quieta = mente;
      secondi = Math.max(1, Math.round(tempo / 1000));
      var dentro = root.contains(document.activeElement);
      bolle.forEach(function (b) {
        b.el.tabIndex = -1;
        b.el.classList.add('gc-pensiero--spento');
      });
      bolle = [];
      tRespiro = 0;
      if (quieta) {
        fiamma.style.transform = 'scale(1)';
        alone.style.opacity = '0.7';
      }
      imposta('respiro');
      if (parola) {
        parola.classList.remove('gc-respiro__parola--cambia');
        parola.textContent = T.inspira;
        timerParola = setTimeout(function () {
          parola.classList.add('gc-respiro__parola--cambia');
          timerParola = setTimeout(function () {
            parola.textContent = T.espira;
            parola.classList.remove('gc-respiro__parola--cambia');
          }, 240);
        }, 1260);
      }
      annuncia(quieta ? T.quieta : T.tempoScaduto);
      if (dentro) metti(btn.salta);

      var fam = scegliFamiglia();
      scelta = null;
      root.querySelectorAll('[data-famiglia]').forEach(function (c) {
        if (c.getAttribute('data-famiglia') === fam) scelta = c;
      });
      pubblica('gioco_fine', {
        secondi: secondi,
        spenti: spenti,
        quieta: quieta,
        candela: scelta ? scelta.getAttribute('data-candela') : '',
        data: data
      });
      timerRespiro = setTimeout(mostraEsito, 3000);
    }

    function mostraEsito() {
      clearTimeout(timerRespiro);
      clearTimeout(timerParola);
      if (stato !== 'respiro') return;
      var dentro = root.contains(document.activeElement) || document.activeElement === document.body;
      fermaCiclo();
      carol.style.transform = '';
      cielo.textContent = '';
      root.querySelectorAll('[data-famiglia]').forEach(function (c) {
        c.hidden = c !== scelta;
      });
      var nome = scelta ? scelta.getAttribute('data-nome') : '';
      titoloEsito.textContent = quieta ? T.finale.replace('[s]', secondi) : T.finaleTempo.replace('[n]', spenti);
      var m = leggiRecord();
      var nota = '';
      if (quieta && (!m || secondi < m)) {
        salvaRecord(secondi);
        if (m) nota = T.nuovoRecord;
      } else if (m) {
        nota = T.record.replace('[s]', m);
      }
      recordEsito.hidden = !nota;
      recordEsito.textContent = nota;
      testoCondividi = (quieta ? T.condividi.replace('[s]', secondi) : T.condividiTempo).replace('[c]', nome);
      if (whatsapp) {
        whatsapp.href = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(testoCondividi + ' ' + URL_PAGINA);
      }
      imposta('fine');
      if (dentro) metti(titoloEsito);
    }

    function condividi() {
      var dati = { title: document.title, text: testoCondividi, url: URL_PAGINA };
      if (navigator.share && (!navigator.canShare || navigator.canShare(dati))) {
        navigator.share(dati).catch(function (e) {
          if (!e || e.name !== 'AbortError') ripiego();
        });
      } else {
        ripiego();
      }
    }

    function ripiego() {
      root.classList.add('gc--ripiego');
      metti(btn.copia);
    }

    function copia() {
      var fatto = function () {
        copiaTesto.textContent = T.copiato;
        annuncia(T.copiato);
        setTimeout(function () {
          copiaTesto.textContent = copiaOrig;
        }, 2500);
      };
      var aMano = function () {
        var ta = document.createElement('textarea');
        ta.value = URL_PAGINA;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        var ok = false;
        try {
          ok = document.execCommand('copy');
        } catch (e) {}
        ta.remove();
        if (ok) {
          fatto();
        } else {
          recordEsito.hidden = false;
          recordEsito.textContent = T.copiaErrore + ' ' + URL_PAGINA;
          annuncia(recordEsito.textContent);
        }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(URL_PAGINA).then(fatto, aMano);
      } else {
        aMano();
      }
    }

    // ---- Eventi ----

    var azioni = {
      inizia: inizia,
      rigioca: inizia,
      pausa: function () {
        pausa(false);
      },
      riprendi: riprendi,
      esci: esci,
      salta: mostraEsito,
      condividi: condividi,
      copia: copia
    };
    Object.keys(btn).forEach(function (k) {
      if (azioni[k]) btn[k].addEventListener('click', azioni[k]);
    });

    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-scopri]');
      if (a && scelta) pubblica('gioco_candela_click', { candela: scelta.getAttribute('data-candela'), azione: 'scopri' });
    });
    root.addEventListener(
      'submit',
      function (e) {
        var c = e.target.closest && e.target.closest('[data-famiglia]');
        if (c) pubblica('gioco_candela_click', { candela: c.getAttribute('data-candela'), azione: 'carrello' });
      },
      true
    );

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || stato !== 'gioco') return;
      if (root.contains(document.activeElement) || document.activeElement === document.body) pausa(false);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pausa(true);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (voci) {
        if (!voci[0].isIntersecting) pausa(true);
      }).observe(scena);
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        misura();
      }).observe(scena);
    } else {
      window.addEventListener('resize', misura);
    }

    root.__gcEsci = esci;
    misura();
    mostraPronto();
    if (btn.inizia) btn.inizia.disabled = false;
  }

  function avvia(contesto) {
    (contesto || document).querySelectorAll('[data-gioco-carol]').forEach(function (root) {
      if (root.__gc) return;
      root.__gc = true;
      Gioco(root);
    });
  }

  avvia();
  document.addEventListener('shopify:section:load', function (e) {
    avvia(e.target);
  });
})();
